(($) => {
  Drupal.behaviors.slGallery = {
    attach() {
      $('.js-gallery-large-view').once('large-view').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        dots: true,
        infinite: false,
        asNavFor: '.js-gallery-thum-view'
      });
      $('.js-gallery-thum-view').once('thum-view').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.js-gallery-large-view',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        arrows: false,
        infinite: false,
      });
    },
  };
})(jQuery);
